// extracted by mini-css-extract-plugin
export default {"element":"PricingTables-module--element--823e3","col":"PricingTables-module--col--ebb1b"};